<template>
    <div style="width:100vw;">
        <div class="w-100 d-flex justify-content-between flex-wrap">
            <div class="card-table-title pt-1 tbl-ttl-mob">
                Vault activity
            </div>
        </div>

        <div class="table-desk">
            <div class="w-100 table-no-filter">
                <v-client-table
                    v-if="tableData.length > 0"
                    class="vue-tables-custom-style"
                    :data="tableData"
                    :columns="columns"
                    :options="options"
                >
                    <template slot="amount" slot-scope="props">
                        <span v-if="props.row.amount != 0">{{
                            moneyFormat(props.row.amount)
                        }}</span>
                        <span v-else>-</span>
                    </template>
                    <template slot="action" slot-scope="props">
                        <span style="text-transform:uppercase;">{{
                            formattingType(props.row.action)
                        }}</span>
                    </template>
                    <template slot="wallet_address" slot-scope="props">
                        <span v-if="props.row.fr_wallet_address === '-'"
                            >-</span
                        >
                        <a
                            v-else
                            target="_blank"
                            class="text-green-gradient"
                            :href="
                                `${getTokenUrl(
                                    props.row.vault.network
                                )}/address/${props.row.fr_wallet_address}`
                            "
                            >{{ shortAddress(props.row.fr_wallet_address) }}</a
                        >
                    </template>
                    <template slot="trx_id" slot-scope="props">
                        <a
                            target="_blank"
                            class="text-green-gradient"
                            :href="
                                `${getTokenUrl(props.row.vault.network)}/tx/${
                                    props.row.trx_id
                                }`
                            "
                            >{{ shortAddress(props.row.trx_id) }}</a
                        >
                    </template>
                </v-client-table>
                <div v-else style="width:100%;text-align:center">
                    No activity in vault
                </div>
            </div>
            <!-- <div class="w-100 d-flex justify-content-center">
                                 <pagination
                                    v-model="page"
                                    :records="tableData.length"
                                    :per-page="10"
                                    :options="paginationOptions"
                                />
                            </div> -->
        </div>
        <div class="table-mob mt-4" v-if="tableData.length > 0">
            <div class="tbl-item" v-for="item in dataShow" :key="item">
                <div class="row mt-3 no-gutters">
                    <div class="col-6 ttl-head">
                        Action
                    </div>
                    <div class="col-6 ttl-head text-right">
                        Amount
                    </div>
                </div>
                <div class="row mt-2 no-gutters">
                    <div class="col-6">
                        <div class="d-flex">
                            <img
                                src="/images/table-dummy-icon-1.svg"
                                style="width:32px; height:32px;"
                                alt=""
                            />
                            <div class="d-flex flex-column my-auto ml-2">
                                <div class="sub-head">
                                    {{
                                        formattingType(
                                            tableData[item - 1].action
                                        )
                                    }}
                                </div>
                                <span class="mt-1">{{
                                    tableData[item - 1].date
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-right">
                        <div class="d-flex flex-column my-auto">
                            <div class="sub-head">
                                <span v-if="tableData[item - 1].amount != 0">{{
                                    moneyFormat(tableData[item - 1].amount)
                                }}</span>
                                <span v-else>-</span>
                            </div>
                            <span
                                v-if="
                                    tableData[item - 1].fr_wallet_address ===
                                        '-'
                                "
                                >-</span
                            >
                            <a
                                v-else
                                target="_blank"
                                class="text-green-gradient"
                                :href="
                                    `${getTokenUrl(
                                        tableData[item - 1].vault.network
                                    )}/address/${
                                        tableData[item - 1].fr_wallet_address
                                    }`
                                "
                                >{{
                                    shortAddress(
                                        tableData[item - 1].fr_wallet_address
                                    )
                                }}</a
                            >
                        </div>
                    </div>
                </div>
                <div class="row mt-3 no-gutters">
                    <div class="col-6 ttl-head">
                        Trx ID
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-6 sub-head">
                        <a
                            target="_blank"
                            class="text-green-gradient"
                            :href="
                                `${getTokenUrl(
                                    tableData[item - 1].vault.network
                                )}/tx/${tableData[item - 1].trx_id}`
                            "
                            >{{ shortAddress(tableData[item - 1].trx_id) }}</a
                        >
                    </div>
                </div>
            </div>
            <div>
                <div class="mt-4 mb-4">
                    <b-button
                        block
                        variant="primary"
                        class="btn"
                        style="padding: 0 8px; margin: auto"
                        v-if="!isHidden"
                        @click="viewMoreData()"
                        >VIEW MORE</b-button
                    >
                </div>
            </div>
        </div>
        <div class="table-mob mt-4 mb-4" v-else>
            <div style="width:100%;text-align:center">No activity in vault</div>
        </div>
    </div>
</template>

<script>
import Pagination from "vue-pagination-2";

export default {
    components: {
        Pagination
    },
    props: {
        vault: null
    },
    data() {
        return {
            tableData: [],
            dataShow: 0,
            LengthData:0,
            page: 1,
            isHidden:false,
            options: {
                headings: {
                    wallet_address: "Wallet Address",
                    trx_id: "Trx ID",
                    start_survey_date: "Started",
                    end_survey_date: "Last Modified"
                },
                requestFunction(data) {
                    return axios
                        .get(`/api/vaults/${data.myID}/transaction-history`, {
                            params: data
                        })
                        .catch(function(e) {
                            this.dispatch("error", e);
                        });
                },
                requestAdapter(data) {
                    return {
                        //myID: self.vault.id
                    };
                }
            },

            paginationOptions: {
                chunk: 5,
                theme: "bootstrap4",
                edgeNavigation: true,
                chunksNavigation: "scroll",
                texts: {
                    count: ""
                }
            },

            columns: ["action", "date", "amount", "wallet_address", "trx_id"]
        };
    },
    methods: {
        shortAddress(str) {
            return (
                str.substring(0, 10) +
                "..." +
                str.substring(str.length - 4, str.length)
            );
        },
        getTransactionHistory() {
            axios
                .get(`/api/vaults/${this.vault.id}/transaction-history`)
                .then(res => {
                    //this.marketYeld = res.data.sort((a, b) => b.rate - a.rate);
                    //
                    this.tableData = res.data.data;
                    if(this.tableData.length < 5) this.dataShow = this.tableData.length;
                    else this.dataShow = 5;
                    this.LengthData  = this.tableData.length;
                })
                .catch(err => {});
        },
        viewMoreData(){
            let restData = this.LengthData - this.dataShow;
            if(restData <= 5){
                this.dataShow += restData;
                this.isHidden = true;
            }else{
                this.dataShow += 5;
            }    
        }
    },
    mounted() {
        this.getTransactionHistory();
    }
};
</script>

<style lang="scss">
> .vue-tables-custom-style {
    th {
        text-align: center;
    }
}

.VuePagination {
    display: flex;
    justify-content: center;
}
</style>
